import { render, staticRenderFns } from "./ClientBadge.vue?vue&type=template&id=278bfb1d"
import script from "./ClientBadge.vue?vue&type=script&lang=js"
export * from "./ClientBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports